import moment from 'moment';
import 'moment-timezone';
import config from './index';
moment.tz.setDefault(config.default_tz);

export default moment;



// WEBPACK FOOTER //
// ./src/config/custom-moment.js